module.exports = __webpack_public_path__ + "img/Img-Placeholder.9d7e6c06.png";